import React from "react";
import { Box, Flex } from "../../components/Flex";
import { Scrollbar } from "../../components/Scrollbar";
import { Label, Title } from "../../components/Text";
import { BarChart } from "../../components/charts/BarChart";
import { filter, toLower } from "lodash";
import moment from "moment";
import { Link } from "react-router-dom";


const ShcDashboard = ({ nodes=[], data, onlyFailed, pathname, onChartBarClick }) => {

    return(
        <Flex height="100%">
            <Scrollbar>
                <Flex height="100%" wrap="wrap" margin={{ "left": "-16px", "top": "-16px", "right": "-16px", "bottom": "-16px"}} padding={{ right: "23px"}}>
                    {nodes.map(node => (
                        <Box
                            flatten
                            key={node}
                            width="calc(50% - 32px)"
                            height="315px"
                            margin={{ top: "16px", left: "16px", bottom: "16px", right: "16px" }}
                            gap={{ bottom: 6 }}
                        >
                            <Flex align="center" gap={{ right: 6 }}>
                                <Label bold capitalize size="14px">Node:</Label>
                                <Link to={pathname + "/" + toLower(node)}>
                                    <Title color="currentColor" h8 bold size="12px">{node}</Title>
                                </Link>
                            </Flex>
                            <Flex height="calc(100% - 35px)">
                                <BarChart
                                    dashboard
                                    onlyFailed={onlyFailed}
                                    node={node}
                                    loading={!(Array.isArray(data))}
                                    data={filter(data, d => toLower(d.node) == toLower(node))}
                                    dateRange={[moment().utc().subtract(1, "month").startOf("day"), moment().utc().subtract(1, "day").endOf("day")]}
                                    onBarClick={onChartBarClick}
                                />
                            </Flex>
                        </Box>
                    ))}
                </Flex>
            </Scrollbar>
        </Flex>
    )
}

export { ShcDashboard }